module.exports = __webpack_public_path__ + "img/compact.d5215a6b.png";